import React from 'react';

import { NodeViewContentHole } from '@atlaskit/editor-common/react-node-view';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { useHandleContentChanges } from '@atlaskit/editor-synced-block-provider';
import type { SyncBlockStoreManager } from '@atlaskit/editor-synced-block-provider';

import { SyncBlockLabel } from './SyncBlockLabel';

interface BodiedSyncBlockWrapperProps {
	node: PMNode;
	syncBlockStore: SyncBlockStoreManager;
}

// Delete this file when cleaning up platform_synced_block_use_new_source_nodeview
export const BodiedSyncBlockWrapper: React.ForwardRefExoticComponent<
	BodiedSyncBlockWrapperProps & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, BodiedSyncBlockWrapperProps>(
	({ node, syncBlockStore }, ref) => {
		// TODO: EDITOR-2429 - this should be debounced (either here or in the data provider) to avoid excessive API writes
		useHandleContentChanges(syncBlockStore, node);

		return (
			<div>
				<NodeViewContentHole data-testid="bodied-sync-block-wrapper" ref={ref} />
				<SyncBlockLabel isSource={true} localId={node.attrs.localId} />
			</div>
		);
	},
);
